import { MapTheme, MapThemeDark } from "./../modules/_Maps";

(function (Drupal, drupalSettings) {

  // Google maps as reusable object.
  Drupal.behaviors.googleMaps = {
    attach: function attach(context) {
      const currentMapTheme =
        MapTheme;
        // Drupal.isDarkMode() ? MapThemeDark : MapTheme;
      const icon = `${window.location.origin}/themes/custom/west_fraser/images/gmap-pin.svg`;

      for (const map in drupalSettings.geofield_google_map) {

        drupalSettings.geofield_google_map[map].map_settings.custom_style_map = {
          "custom_style_control": 1,
          "custom_style_name": "Wf Default",
          "custom_style_options": JSON.stringify(currentMapTheme),
          "custom_style_default": 1
        };

        // drupalSettings.geofield_google_map[map].map_settings.map_marker_and_infowindow.icon_image_path = icon;
        // for (const marker in drupalSettings.geofield_google_map[map].map_settings.markers) {
        //   drupalSettings.geofield_google_map[map].map_settings.markers[marker].icon = icon;
        // }
      }
    }
  };

}(Drupal, drupalSettings));

